import React from "react";
import { FaPlus } from "react-icons/fa";
import usePermissions from "../hooks/usePermissions";

const AddButton = ({ onClick, moduleName }) => {
  const perms = usePermissions(moduleName) || {};
  //console.log("[DEBUG AddButton] moduleName:", moduleName, "perms:", perms);
  const { add: hasAddAccess = false } = perms;

  if (!hasAddAccess) return null;
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center p-2 mb-3 text-white bg-green-600 rounded hover:bg-green-700"
    >
      <FaPlus size={14} />
    </button>
  );
};

export default AddButton;
